module.exports = __webpack_public_path__ + "img/customer-tit.5c00cca5.png";